<div class="cvGroupAssignToolOverlay " *ngIf="awardedIsVisible"></div>
<div class="cvGroupAssignToolPopupContainer popupContainer modal-dialog modal-xl modal-dialog-centered"
    *ngIf="awardedIsVisible">
    <div class="modal-content maDetailsPopup">
        <div class="FlexRowNoWrap topContainer modalContent">
            <div class="FlexRowNoWrap nameHolder modalHeader">
                <div class="FlexRowNoWrap FlexAlignVertical nameText txtOverflow">
                    <div class="modalHeaderText" runat="server" cvLocalizedText langSection="Manual_Awards"
                        langKey="Details">Details</div>
                </div>
            </div>
            <div class="closeImgHolder">
                <div class="closeImg" (click)="closePopup()"></div>
            </div>
        </div>
        <div class="maDetailsMain py-3 modalContent mainDetails" *ngIf="selectedAward">
            <div class="maItemLeft">
                <div class="maItemImg imgItem">
                    <img [src]="'../Admin/ImageResizer.aspx?imgid=' + selectedAward.BadgeID + '&w=100&h=100'" />
                </div>
                <div class="text-center mt-4 pt-2">
                    <div>{{selectedAward.AwardedCount != null ? selectedAward.AwardedCount : 0}}</div>
                    <div runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Awarded">Awarded</div>
                </div>
            </div>
            <div class="maItemRight itemRigth">
                <div class="maItemTitle" title="{{selectedAward.Name}}">{{selectedAward.Name}}</div>
                <div class="maItemDetailsLine">
                    <div class="maItemDetailsCreated">
                        <span class="maItemCreatedIcon mr-2"></span>
                        <span class="maItemCreatedText"><span runat="server" cvLocalizedText langSection="Manual_Awards"
                                langKey="Created">Created</span> {{selectedAward.DateCreatedForView}}</span>
                    </div>
                    <div class="maItemSeeDetailsLink" (click)="awardedIsVisible"></div>
                </div>
                <div class="maItemDesc full" title="{{selectedAward.Description}}" style="height: 80px;">
                    {{selectedAward.Description}}</div>
                <div class="d-flex">
                    <div>
                        <span class="maItemPayoutCoinIcon mr-1"></span>
                        <span class="maItemPayoutCoinVal">{{selectedAward.Coins}}</span>
                    </div>
                    <div class="ml-5">
                        <span class="d-inline-block align-text-bottom"><svg class="fill-dimetapp" width="20px"
                                height="20px">
                                <use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                            </svg></span>
                        <span class="maItemPayoutCoinVal">{{selectedAward.XP}}</span>
                    </div>
                    <div class="ml-auto btn btn-secondary cursor-pointer" (click)="onOpenAwardPopup();"
                        runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Give">Give</div>
                        <cv-give-award-popup
                        [awardToolVisible]="awardToolVisible"
                        (closeAwardPopup)="closeAwardPopup()"
                        [manualAward]="manualAward"
                        [loadHistory]="loadHistory"
                        (onLoadHistory)="onLoadHistory()"
                        ></cv-give-award-popup>
                </div>
            </div>
        </div>
        <div class="modalContent historyContent">
            <div *ngIf="loadingHistory" class="loaderContent">
                <cv-loader class="cvLoader" size="large" [overlay]="false"></cv-loader>
            </div>
            <div class="maDetailsHistory detailsHistory">
                <ag-grid-angular #awardedPopupGrid *ngIf="gridOptions" class="ag-theme-material lato-regular h-100 w-100 overflow-auto"
                    [gridOptions]="gridOptions" enableFilter="true">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>
